<template>
  <span v-if="data.hasOwnProperty('isIncrease')  && data.hasOwnProperty('percentDifferent')" :class="{'green--text': data.isIncrease, 'red--text': !data.isIncrease}"><v-icon small :color="data.isIncrease ? 'green': 'red'">{{ data.isIncrease ? 'mdi-arrow-up-thin' : 'mdi-arrow-down-thin' }}</v-icon> {{ data.value }} ({{ data.percentDifferent }}%)</span>
  <span v-else><v-icon small>mdi-minus</v-icon> {{ data.value }}</span>
</template>

<script>
  export default {
    name: 'MonthlyTableRow',
    props: {
      data: {
        type: Object,
        required: true
      }
    }
  }
</script>

<style scoped>

</style>
